// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@wfp/ui/assets/css/styles.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___, "", false, undefined, "legacy-wfp");
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * WFP UI is the legacy theme. Its global reset and typography still support
 * older screens, but they should not outrank Tailwind component utilities.
 */
`, "",{"version":3,"sources":["webpack://./src/assets/css/wfp.css"],"names":[],"mappings":"AAAA;;;EAGE","sourcesContent":["/*\n * WFP UI is the legacy theme. Its global reset and typography still support\n * older screens, but they should not outrank Tailwind component utilities.\n */\n@import \"@wfp/ui/assets/css/styles.min.css\" layer(legacy-wfp);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
